import { Tooltip } from "@monolith-forensics/monolith-ui";
import { FC, ReactNode } from "react";
import { ChevronRight } from "react-feather";
import { Link } from "react-router-dom";
import styled from "styled-components";

const HeaderWrapper = styled.div`
  margin-bottom: 10px;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const BreadcrumbSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2px;
`;

const PageName = styled.h2`
  font-weight: 500;
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 10px;
  margin: 0;
  line-height: 1.2;
`;

const BackLink = styled.h2`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 5px;
  width: fit-content;
  color: ${({ theme }) => theme.palette.text.secondary};
  font-weight: 400;
  opacity: 0.8;
  cursor: pointer;
  margin: 0;
  line-height: 1.2;

  &:hover {
    color: ${({ theme }) => theme.palette.text.primary};
    text-decoration: underline;
  }
`;

const BackLinkText = styled.span`
  display: flex;
  gap: 5px;
  align-items: center;
`;

const SeparatorWrapper = styled.div`
  display: flex;
  align-items: baseline;
  margin-top: 2px;
`;

const Separator = styled(ChevronRight)`
  color: ${({ theme }) => theme.palette.text.secondary};
`;

interface BreadcrumbPageHeaderProps {
  sectionName: ReactNode;
  pageName: ReactNode;
  TooltipContent?: FC;
  href?: string;
  onSectionClick?: () => void;
}

export const BreadcrumbPageHeader: FC<BreadcrumbPageHeaderProps> = ({
  sectionName,
  pageName,
  TooltipContent,
  href,
  onSectionClick,
}) => {
  return (
    <HeaderWrapper>
      <ContentWrapper>
        <BreadcrumbSection>
          {!onSectionClick ? (
            /* @ts-ignore */
            <Link to={href || -1}>
              <BackLink>
                <BackLinkText>{sectionName}</BackLinkText>
              </BackLink>
            </Link>
          ) : (
            <BackLink onClick={onSectionClick}>
              <BackLinkText>{sectionName}</BackLinkText>
            </BackLink>
          )}
          <SeparatorWrapper>
            <Separator size={15} />
          </SeparatorWrapper>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              cursor: "pointer",
            }}
          >
            {TooltipContent ? (
              <>
                <Tooltip content={<TooltipContent />}>
                  <PageName>{pageName}</PageName>
                </Tooltip>
              </>
            ) : (
              <PageName>{pageName}</PageName>
            )}
          </div>
        </BreadcrumbSection>
      </ContentWrapper>
    </HeaderWrapper>
  );
};
